var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"video-wrapper"},[_c('iframe',{attrs:{"allowfullscreen":"","src":`https://www.youtube.com/embed/${this.selectedVideo.id.videoId}`}})]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.selectedVideo.snippet.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }